import axios from 'axios'
import { i18n } from '../../../plugins/i18n'
import { allSitesConst } from '../../../modules/sitesConst'

export const companiesStoreCompetitor = {
  namespaced: true,
  state: {
    data: null,
    // 表示切り替え時にロードした状態に戻すのに使う
    competitorSites: null,
    originalCompetitorSites: null,
    loading: false,
  },
  mutations: {
    initNewCompetitor(state) {
      state.data = {
        attributes: {
          name: null,
          competitor_brand_id: null
        }
      }
      state.originalCompetitorSites = []
    },
    prepareApi(state) {
      state.loading = true
    },
    readCompetitor(state) {
      state.data = null
      state.loading = true
    },
    readCompetitorSuccess(state, payload) {
      state.data = payload.data
      state.originalCompetitorSites = state.data.attributes.sites
      state.loading = false
    },
    combineCompetitorSite(state, sites) {
      const filterSitesConst =  allSitesConst.filter(site => !['docomo', 'yahoo_place'].includes(site.siteType))
      state.competitorSites = filterSitesConst.map((siteConst) => {
        const matchedSite = sites.find((s) => (s.site_type === siteConst.siteType || s.siteType === siteConst.siteType))
        return {
          ...siteConst,
          url: matchedSite ? matchedSite.url : ''
        }
      })
    },
    apiSuccess(state,) {
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
  },
  getters: {
    query: (state) => {
      const attributes = state.data.attributes
      return {
        competitor: {
          name: attributes.name,
          competitor_brand_id: attributes.competitor_brand_id,
        },
        competitor_address: {
          postal_code: attributes.postal_code,
          prefecture: attributes.prefecture,
          lines: attributes.address_lines,
        },
        sites: state.competitorSites.map(s => ({site_type: s.siteType, url: s.url }))
      }
    },
  },
  actions: {
    initNewCompetitor({ commit }) {
      commit('initNewCompetitor')
      commit('combineCompetitorSite', [])
    },
    resetCompetitorSites({ commit, state }) {
      commit('combineCompetitorSite', state.originalCompetitorSites)
    },
    readCompetitor({ commit }, { company_uuid, store_uuid, competitor_id }) {
      commit('readCompetitor')
      return axios
        .get('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/competitors/' + competitor_id + '.json')
        .then(res => {
          commit('readCompetitorSuccess', res.data)
          commit('combineCompetitorSite', res.data.data.attributes.sites)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
    createCompetitor({ commit, state, getters }, {company_uuid, store_uuid}) {
      if (state.loading) return

      commit('flash/clearFlash', null, { root: true })
      commit('prepareApi')
      return axios
        .post('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/competitors.json', getters.query)
        .then(() => {
          commit('apiSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.created', { value: i18n.t('models.competitor.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
    updateCompetitor({ commit, state, getters }, {company_uuid, store_uuid, competitor_id}) {
      if (state.loading) return

      commit('flash/clearFlash', null, { root: true })
      commit('prepareApi')
      return axios
        .put('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/competitors/' + competitor_id + '.json', getters.query)
        .then(() => {
          commit('apiSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updatedInfo', { value: i18n.t('models.competitor.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
  }
}
